import { rootStore } from '../model/RootStoreContext';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

export interface IImageUploadController {
    handleImageUpload: (filePath: File, projectId: string) => Promise<IImageControllerResult>;
}

interface IImageControllerResult {
    uploadSucceeded: boolean | null;
    res: IImageUploadVm | null;
}

export const useImageUploadController = () => {

    const routeKindId = rootStore.entityVersionStore.getCurrentEntityVersion().kindVersionSummary.kindId;
    const publishNotification = usePublishSnackbarNotification();

    const imageControllerResult: IImageControllerResult = {
        uploadSucceeded: null,
        res: null
    };

    const handleImageUpload = async (imageFile: File, projectId: string) => {

        const formData = new FormData();

        formData.append('file', imageFile);
        formData.append('projectId', projectId);

        await rootStore.entityVersionStore.saveImagePropertyValue<IImageUploadVm>(routeKindId, formData)
            .then(async (res: IImageUploadVm) => {
                imageControllerResult.uploadSucceeded = true;
                imageControllerResult.res = res;

                return imageControllerResult;
            })
            .catch(e => {
                imageControllerResult.uploadSucceeded = false;
                publishNotification({
                    text: `Error uploading image: ${e.toString()}`,
                    canClose: true
                });
                return imageControllerResult;
            });

        return imageControllerResult;
    };

    const controller: IImageUploadController = {
        handleImageUpload: handleImageUpload
    };

    return controller;
};

export interface IImageUploadVm {
    status: string,
    data: {
        path: string;
    }
}
